import React, { useState } from "react";
import toast from "react-hot-toast";
import axios from "axios";
import Select from "react-select";
import { DatePicker } from "antd";
import moment from "moment";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import { useAtom } from "jotai";
import { gbState } from "../../../components/shared/GlobalState";
import {
  FaCalendarAlt,
  FaUser,
  FaVenusMars,
  FaUsers,
  FaBirthdayCake,
  FaPray,
  FaComments,
  FaChurch,
  FaCross,
} from "react-icons/fa";

const AddBaptismChild = () => {
  let navigate = useNavigate();
  const inputWidth = "100%";
  const style = {
    control: (base) => ({
      ...base,
      border: "1px solid #e2e8f0",
      borderRadius: "0.375rem",
      boxShadow: "none",
      "&:hover": {
        border: "1px solid #4299e1",
      },
    }),
  };

  const [{ errorLogApi, placeHolderText }] = useAtom(gbState);
  const [formData, setFormData] = useState({
    baptism_date: null,
    name: "",
    sex: null,
    parents_name: "",
    date_of_birth: null,
    god_parents: "",
    remarks: "",
    presbyter_incharge: "",
    baptised_presbyter: "",
  });

  const genderOptions = [
    { value: 1, label: "Male" },
    { value: 2, label: "Female" },
    { value: 3, label: "Other" },
  ];

  const handleChange = ({ currentTarget: input }) => {
    setFormData({
      ...formData,
      [input.name]: input.value,
    });
  };

  const dropDownChange = (selected, dropdown) => {
    setFormData({
      ...formData,
      [dropdown.name]: selected,
    });
  };

  function formatString(str) {
    const words = str.replace(/_/g, " ").split(" ");
    return words
      .map((word, index) =>
        index === 0 ? word.charAt(0).toUpperCase() + word.slice(1) : word
      )
      .join(" ");
  }

  const handleBaptismRegister = () => {
    const fieldToValidate = [
      "baptism_date",
      "name",
      "sex",
      "parents_name",
      "date_of_birth",
      "god_parents",
    ];
    const emptyFields = fieldToValidate
      .filter((f) => !formData[f])
      .map(formatString);

    if (emptyFields.length > 0) {
      return toast.error(`${emptyFields.join(", ")} cannot be empty`);
    }

    let userToken = localStorage.getItem("token");
    const config = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/baptism/add`,
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
      data: formData,
    };

    axios(config)
      .then(function (response) {
        toast.success(response?.data?.message);
        navigate("/baptism/list");
      })
      .catch(function (error) {
        toast.error(
          error.response?.data
            ? JSON.stringify(error.response.data)
            : "An error occurred"
        );
        errorLogApi(error, "AddBaptism", "/baptism/add");
      });
  };

  return (
    <div className="max-w-4xl p-6 mx-auto bg-white rounded-lg shadow-lg">
      <h2 className="mb-6 text-2xl font-semibold text-gray-800">
        Add Baptism Record
      </h2>
      <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
        <div className="space-y-4">
          <div>
            <label className="block mb-1 text-sm font-medium text-gray-700">
              Baptism Date
            </label>
            <DatePicker
              className="w-full border-gray-300 rounded-md shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
              name="baptism_date"
              onChange={(date, dateString) =>
                setFormData({ ...formData, baptism_date: dateString })
              }
              disabledDate={(current) =>
                current && current > dayjs().endOf("day")
              }
              format="MM-DD-YYYY"
              suffixIcon={<FaCalendarAlt className="text-gray-400" />}
            />
          </div>
          <div>
            <label className="block mb-1 text-sm font-medium text-gray-700">
              Name
            </label>
            <div className="relative">
              <input
                className="w-full py-2 pl-10 pr-3 leading-5 placeholder-gray-500 bg-white border border-gray-300 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                name="name"
                type="text"
                required
                placeholder="Full Name"
                onChange={handleChange}
                value={formData.name}
              />
              <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                <FaUser className="w-5 h-5 text-gray-400" />
              </div>
            </div>
          </div>
          <div>
            <label className="block mb-1 text-sm font-medium text-gray-700">
              Sex
            </label>
            <div className="relative">
              <div className="absolute inset-y-0 left-0 z-10 flex items-center pl-3 pointer-events-none">
                <FaVenusMars className="w-5 h-5 text-gray-400" />
              </div>
              <Select
                name="sex"
                onChange={dropDownChange}
                options={genderOptions}
                className="w-full"
                placeholder={placeHolderText("Select Gender")}
                styles={{
                  ...style,
                  control: (provided) => ({
                    ...provided,
                    paddingLeft: "2.5rem",
                  }),
                }}
              />
            </div>
          </div>
          <div>
            <label className="block mb-1 text-sm font-medium text-gray-700">
              Parents Name
            </label>
            <div className="relative">
              <input
                className="w-full py-2 pl-10 pr-3 leading-5 placeholder-gray-500 bg-white border border-gray-300 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                name="parents_name"
                type="text"
                required
                placeholder="Parents' Names"
                onChange={handleChange}
                value={formData.parents_name}
              />
              <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                <FaUsers className="w-5 h-5 text-gray-400" />
              </div>
            </div>
          </div>
        </div>
        <div className="space-y-4">
          <div>
            <label className="block mb-1 text-sm font-medium text-gray-700">
              Date of Birth
            </label>
            <DatePicker
              className="w-full border-gray-300 rounded-md shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
              name="date_of_birth"
              onChange={(date, dateString) =>
                setFormData({ ...formData, date_of_birth: dateString })
              }
              disabledDate={(current) =>
                current && current > moment().endOf("day")
              }
              format="MM-DD-YYYY"
              suffixIcon={<FaBirthdayCake className="text-gray-400" />}
            />
          </div>
          <div>
            <label className="block mb-1 text-sm font-medium text-gray-700">
              God Parents
            </label>
            <div className="relative">
              <input
                className="w-full py-2 pl-10 pr-3 leading-5 placeholder-gray-500 bg-white border border-gray-300 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                name="god_parents"
                type="text"
                required
                placeholder="God Parents' Names"
                onChange={handleChange}
                value={formData.god_parents}
              />
              <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                <FaPray className="w-5 h-5 text-gray-400" />
              </div>
            </div>
          </div>
          <div>
            <label className="block mb-1 text-sm font-medium text-gray-700">
              Presbyter Incharge
            </label>
            <div className="relative">
              <input
                className="w-full py-2 pl-10 pr-3 leading-5 placeholder-gray-500 bg-white border border-gray-300 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                name="presbyter_incharge"
                type="text"
                required
                placeholder="Presbyter Incharge"
                onChange={handleChange}
                value={formData.presbyter_incharge}
              />
              <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                <FaChurch className="w-5 h-5 text-gray-400" />
              </div>
            </div>
          </div>
          <div>
            <label className="block mb-1 text-sm font-medium text-gray-700">
              Baptised Presbyter
            </label>
            <div className="relative">
              <input
                className="w-full py-2 pl-10 pr-3 leading-5 placeholder-gray-500 bg-white border border-gray-300 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                name="baptised_presbyter"
                type="text"
                required
                placeholder="Baptised Presbyter"
                onChange={handleChange}
                value={formData.baptised_presbyter}
              />
              <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                <FaCross className="w-5 h-5 text-gray-400" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="mt-6">
        <label className="block mb-1 text-sm font-medium text-gray-700">
          Remarks
        </label>
        <div className="relative">
          <textarea
            className="w-full py-2 pl-10 pr-3 leading-5 placeholder-gray-500 bg-white border border-gray-300 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
            name="remarks"
            rows={3}
            placeholder="Additional remarks"
            onChange={handleChange}
            value={formData.remarks}
          />
          <div className="absolute pointer-events-none top-3 left-3">
            <FaComments className="w-5 h-5 text-gray-400" />
          </div>
        </div>
      </div>
      <div className="flex justify-end mt-8 space-x-4">
        <button
          className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          onClick={() => navigate(-1)}
        >
          Back
        </button>
        <button
          className="px-4 py-2 text-sm font-medium text-white bg-indigo-600 border border-transparent rounded-md shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          onClick={handleBaptismRegister}
        >
          Create Record
        </button>
      </div>
    </div>
  );
};

export default AddBaptismChild;
